// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb_breadcrumb__C9v6O","divider":"breadcrumb_divider__uhJgI","more-icon":"breadcrumb_more-icon__qMOLn"};